// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__uKUMw","name":"Header_name__1z9kl","birthday":"Header_birthday__t9_h9","skeleton":"Header_skeleton__1BCc2"};